import { createSlice } from '@reduxjs/toolkit';

export const slice = createSlice({
  name: 'app',
  initialState: {
    nav: false,
  },
  reducers: {
    setNav: (state, action) => {
      state.nav = !!action.payload;
    },
  },
});

export const { setNav } = slice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectNav = state => state.app.nav;

export default slice.reducer;
